import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditBpComponent } from './edit-bp/edit-bp.component';
import { ReadBpComponent } from './read-bp/read-bp.component';
import { CreateBpComponent } from './create-bp/create-bp.component';
import { ValidateBpComponent } from './validate-bp/validate-bp.component';
import { BpListComponent } from './table/bp-list/bp-list.component';
import { BpLineListArrayComponent } from './table/bp-line-list-array/bp-line-list-array.component';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BpComponentsService } from './bp-components.service';
import { AuthGuard } from 'src/app/shared/services/auth.guard';
import { JwtHelper } from 'src/app/shared/services/jwtHelper';
import { AmountComponentService } from '../amount.component.service';
import { ListeBpComponent } from './liste-bp/liste-bp.component';
import { BpFormComponent } from './bp-form/bp-form.component';
import { FacturationBpComponent } from './facturation-bp/facturation-bp.component';
import { FixedBpLineListValidationComponent } from './table/fixed-bp-line-list-validation/fixed-bp-line-list-validation.component';
import { BpLineFacturationArrayComponent } from './table/bp-line-facturation-array/bp-line-facturation-array.component';
import { CyclesBpComponent } from './cycles-bp/cycles-bp.component';
import { ModalAddBpDocumentComponent } from './modals/modal-add-bp-document/modal-add-bp-document.component';
import { ModalShowBpDocumentComponent } from './modals/modal-show-bp-document/modal-show-bp-document.component';
import { PdfBpComponent } from './pdf-bp/pdf-bp.component';
import { ModalCreateBpLineComponent } from './modals/modal-create-bp-line/modal-create-bp-line.component';
import { BcModule } from '../bc/bc.module';




@NgModule({
  declarations: [
    EditBpComponent,
    ReadBpComponent,
    CreateBpComponent,
    ValidateBpComponent,
    BpListComponent,
    ListeBpComponent,
    BpLineListArrayComponent,
    BpLineFacturationArrayComponent,
    BpFormComponent,
    FacturationBpComponent,
    ModalAddBpDocumentComponent,
    ModalShowBpDocumentComponent,
    FixedBpLineListValidationComponent,
    CyclesBpComponent,
    PdfBpComponent,
    ModalCreateBpLineComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatCardModule,
    BcModule
  ],
  providers:  [
    BpComponentsService,
    AmountComponentService,
    AuthGuard,
    JwtHelper
  ]
})
export class BpModule { }
